import { getAuthHeaders } from './authHeaders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export async function getPublicOrderLiveLocation(token) {
  const url = `${API_BASE_URL}/orders/tracking/${encodeURIComponent(token)}/live-location`;
  const response = await fetch(url, { method: 'GET' });
  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return await response.json();
}

export async function updatePublicOrderDestinationLocation(token, payload) {
  const url = `${API_BASE_URL}/orders/tracking/${encodeURIComponent(token)}/destination-location`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return await response.json();
}

export async function adminGetCourierLiveLocation(orderCode) {
  const headers = await getAuthHeaders();
  const url = `${API_BASE_URL}/orders/${encodeURIComponent(orderCode)}/courier/live-location`;
  const response = await fetch(url, { method: 'GET', headers });
  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return await response.json();
}
